/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { FaPlus, } from "react-icons/fa6";
import AddLeads from "./AddLeads";
import { useDispatch, useSelector } from "react-redux";
import {
  archiveLeadData,
  editLeadmaster,
  getLeadmaster,
  handleImportFile,
  removeLeadmaster,
} from "../../Redux/LeadsSlice";
import { MdDeleteForever } from "react-icons/md";
import { BiEdit } from "react-icons/bi";
import { BsThreeDotsVertical } from "react-icons/bs";
import sweetAlert from "../Common/sweetAlert";
import { useNavigate } from "react-router-dom";
import Loading from "../Common/Loading";
import { FormatDateMoment } from "../Common/defaultValue"
import { RxDotsHorizontal } from "react-icons/rx";
import * as XLSX from 'xlsx';
import { GoArchive } from "react-icons/go";
import moment from "moment";
import { getActivityIcon } from "../Common/Common";
import { IoIosWarning } from "react-icons/io";
import { IoSearch } from "react-icons/io5";
import Pagination from "../Common/Pagination";
import { getMenuAll, getMenuPermission } from "../../Redux/SideBarSlice";


const Inbox = ({
  isVisible,
  setIsVisible,
  setSidebarOpen,
  sidebarOpen,
  isDark,
  setIsDark,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const store = useSelector((state) => state.root.leads);
  const { user } = useSelector((state) => state.root.auth);
  // Full-page loader only when Redux has no cached list yet (first load / hard refresh)
  const loading = store?.loading && !(store?.leadsData?.length > 0);

  const [loadFist, setLoadFist] = useState(true);
  const [openModel, setOpenModel] = useState(false);
  const [leadData, setLeadData] = useState([]);
  // InfoDetailsLeads model
  const [activeButton, setActiveButton] = useState(1);
  const [type, setType] = useState(false);
  // pagination start
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const [sortedField, setSortedField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectcheck, setSelectCheck] = useState(false);
  const [AciteOption, setAciteOption] = useState(false);
  const [openActionMenuId, setOpenActionMenuId] = useState(null);
  const [permissions, setPermissions] = useState({
    isDelete: false,
    isSave: false,
    isView: false,
  });

  useEffect(() => {
    const handleOutsideClick = () => setOpenActionMenuId(null);
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  useEffect(() => {
    dispatch(getMenuAll()).then((item) => {

      const findData = item?.payload?.data?.menu.reduce((result, menuItem) => {
        if (menuItem?.submenu && Array.isArray(menuItem?.submenu)) {
          const submenuItem = menuItem?.submenu?.find((submenuItem) => submenuItem?.pageName === "Leads Inbox");
          if (submenuItem) { result = submenuItem; }
        }
        return result;
      }, null);

      if (findData) {
        const ItemID = findData?.moduleID;
        const payload = { UserRoleID: user?.userRoleID, ModuleID: ItemID };
        dispatch(getMenuPermission(payload)).then((permissionItem) => {
          if (Array.isArray(permissionItem?.payload?.data) && permissionItem?.payload?.data?.length > 0) {
            setPermissions(permissionItem?.payload?.data[0]);
          }
        });
      }
    });
  }, []);

  useEffect(() => {
    if (loadFist) {
      setLoadFist(false);
      dispatch(getLeadmaster({ search: '', limit: 0, pageNumber: 0, objSearch: { IsArchived: type } }));
    }
  }, [loadFist, dispatch, type]);

  useEffect(() => {
    setCurrentPage(1)
  }, [searchTerm]);

  useEffect(() => {
    if (selectcheck) {
      if (selectedItems?.length === sortedAndPaginatedData?.length) {
        setSelectAllChecked(true);
      }
    }
  }, [selectcheck, selectedItems]);

  const handlePageChange = (pageNumber) => { setCurrentPage(pageNumber); };


  const filteredData = store?.leadsData ? store?.leadsData?.filter((item) => Object.values(item).some((value) => value && value.toString().toLowerCase().includes(searchTerm.toLowerCase()))) : []

  const sortData = (data, field, order) => {
    const sortedData = [...data];
    sortedData.sort((a, b) => {
      const aTrimmed = a[field]?.trim();
      const bTrimmed = b[field]?.trim();

      if (order === "asc") {
        return aTrimmed?.localeCompare(bTrimmed);
      }

    });
    return sortedData;
  };

  const handleSort = (field) => {
    if (sortedField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortOrder("asc");
      setSortedField(field);
    }
  };

  // Sort and paginate the data
  const sortedAndPaginatedData = sortData(filteredData, sortedField, sortOrder).slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);
  const totalPages = Math.ceil(filteredData?.length / rowsPerPage);

  const handleCheckboxChange = (selectID) => {
    setSelectAllChecked(false);
    setSelectCheck(true);
    if (selectedItems?.includes(selectID)) {
      setSelectedItems(selectedItems?.filter((id) => id !== selectID));
    } else {
      setSelectedItems([...selectedItems, selectID]);
    }
  };

  const handleSelectAll = () => {
    setSelectAllChecked(!selectAllChecked);
    if (selectedItems?.length === sortedAndPaginatedData?.length) {
      setSelectedItems([]);
    } else {
      const allIds = sortedAndPaginatedData?.map((items) => items?.leadID);
      setSelectedItems(allIds);
    }
  };

  const handleButtonClick = (buttonIndex) => {
    if (buttonIndex === 1) {
      setType(false);
    } else {
      setType(true);
    }
    setSearchTerm('')
    setActiveButton(buttonIndex);
    setLoadFist(true);
  };

  const editLead = async (id) => {
    try {
      const response = await dispatch(editLeadmaster(id));
      if (response) {
        setOpenModel(true);
        const data = response.payload.data;
        setLeadData(data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleDelete = async () => {
    try {
      const result = await sweetAlert.confirm(
        "Are you sure?",
        "Are you sure you want to delete this!"
      );
      if (result.isConfirmed) {
        dispatch(removeLeadmaster(selectedItems)).then((res) => {
          setCurrentPage(1)
          setLoadFist(true);
        })
        sweetAlert.success("Deleted successfully");
      }
      setSelectedItems([]);
      setSelectAllChecked(false);
    } catch (error) {
      console.error("Error:", error);
      sweetAlert.error("An error occurred");
    }
  };

  const togglemodelLead = () => {
    setOpenModel(!openModel);
    setLeadData([]);
  };

  const infoDetailsLeads = async (id) => {
    try {
      const response = await dispatch(editLeadmaster(id));
      if (response) {
        const data = response.payload.data;
        setLeadData(data);
        navigate(`/detailsLead/${id}`);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleExport = () => {
    const data = store?.leadsData?.map(item => ({
      Title: item.title,
      ContactPerson: item.personName,
      CurrencyName: item.currencyName,
      LabelName: item.labelName,
      ExpectedClosedDate: item.expectedCloseDate,
      VisibleToName: item.visibleName,
      PeopleName: "",
      OrganizationName: item.organizationName,
      Value: item.value,
      SourceChannel: item.sourceChannel,
    }));
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Leads");
    XLSX.writeFile(workbook, "leads_data.xlsx");
    setAciteOption(!AciteOption)
  };

  const uploadExcel = async (e) => {
    // navigate('/settings/import-Data')
    // return
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('ExcelFilePath', file);

    try {
      dispatch(handleImportFile(formData))
      setAciteOption(!AciteOption)

    } catch (error) {
      console.error('Upload error:', error);
    }
  };

  const totalLeads = store?.leadsData?.length || 0;
  const newLeads = store?.leadsData?.filter(x => x?.labelName?.toLowerCase() === 'new' || !x?.activityDetails?.length).length || 0;
  const unassignedLeads = store?.leadsData?.filter(x => !x?.personName).length || 0;
  const contactedLeads = store?.leadsData?.filter(x => x?.activityDetails?.length > 0).length || 0;
  const qualifiedLeads = store?.leadsData?.filter(x => x?.labelName?.toLowerCase() === 'qualified' || x?.value > 50000).length || 0;
  const convertedLeads = store?.leadsData?.filter(x => x?.labelName?.toLowerCase() === 'converted' || x?.labelName?.toLowerCase() === 'won').length || 0;

  return (
    <>
      <div className="flex flex-1">
        <div className="page-wrapper relative ml-auto w-[calc(100%-326px)] px-4 pt-[54px] duration-300">

          {/* Page Header */}
          <div className="crm-page-header">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="crm-page-title">Leads Inbox</h1>
                <ol className="crm-breadcrumb">
                  <li><a href="/Analytics">Disploy</a></li>
                  <li>/</li>
                  <li>Leads</li>
                  <li>/</li>
                  <li className="active">Leads Inbox</li>
                </ol>
              </div>
              {permissions?.isSave && !type && (
                <button className="crm-new-btn" onClick={() => setOpenModel(true)}>
                  <FaPlus size={11} />
                  New Lead
                </button>
              )}
            </div>
          </div>

          <div className="xl:w-full min-h-[calc(100vh-138px)] relative pb-14">

            {/* Stat Cards */}
            <div className="crm-stats-row">
              <div className="crm-stat-card crm-card-indigo">
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-indigo">
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                      <circle cx="9" cy="7" r="4" />
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">Total Leads</p>
                    <p className="stat-value">{totalLeads}</p>
                    <p className="stat-trend-up">↑ 18% vs last 7 days</p>
                  </div>
                </div>
              </div>
              <div className="crm-stat-card crm-card-green">
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-green">
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                      <circle cx="8" cy="7" r="4" />
                      <line x1="20" y1="8" x2="20" y2="14" />
                      <line x1="23" y1="11" x2="17" y2="11" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">New Leads</p>
                    <p className="stat-value">{newLeads}</p>
                    <p className="stat-trend-up">↑ 12% vs last 7 days</p>
                  </div>
                </div>
              </div>
              <div className="crm-stat-card crm-card-orange">
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-orange">
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="12" />
                      <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">Unassigned</p>
                    <p className="stat-value">{unassignedLeads}</p>
                    <p className="stat-trend-down">↓ 8% vs last 7 days</p>
                  </div>
                </div>
              </div>
              <div className="crm-stat-card crm-card-blue">
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-blue">
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">Contacted</p>
                    <p className="stat-value">{contactedLeads}</p>
                    <p className="stat-trend-up">↑ 20% vs last 7 days</p>
                  </div>
                </div>
              </div>
              <div className="crm-stat-card crm-card-purple" style={{ borderTop: '4px solid #a855f7' }}>
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-purple" style={{ color: '#a855f7', background: '#f3e8ff' }}>
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">Qualified</p>
                    <p className="stat-value">{qualifiedLeads}</p>
                    <p className="stat-trend-up">↑ 15% vs last 7 days</p>
                  </div>
                </div>
              </div>
              <div className="crm-stat-card crm-card-sky">
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-sky">
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                      <polyline points="22 4 12 14.01 9 11.01" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">Converted</p>
                    <p className="stat-value">{convertedLeads}</p>
                    <p className="stat-trend-up">↑ 10% vs last 7 days</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="crm-panel">
              {/* Tab Navigation + Filters */}
              <div className="flex items-center justify-between px-4 pt-2 border-b border-slate-100 flex-wrap gap-3">
                <div className="crm-tabs" style={{ borderBottom: 'none' }}>
                  <button
                    className={`crm-tab-btn ${activeButton === 1 ? 'active' : ''}`}
                    onClick={() => handleButtonClick(1)}
                  >
                    Inbox
                  </button>
                  <button
                    className={`crm-tab-btn ${activeButton === 2 ? 'active' : ''}`}
                    onClick={() => handleButtonClick(2)}
                  >
                    Archive
                  </button>
                </div>

                <div className="flex items-center gap-3 ml-auto pb-2">
                  <div className="crm-search-box">
                    <IoSearch size={14} />
                    <input
                      type="text"
                      placeholder="Search leads..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>

                  {permissions?.isDelete && selectedItems && selectedItems.length > 0 && (
                    <button
                      className="p-2 rounded-lg text-red-500 hover:bg-red-50 transition-colors"
                      onClick={handleDelete}
                      title="Delete Selected"
                    >
                      <MdDeleteForever size={18} />
                    </button>
                  )}

                  <div className="relative">
                    <button
                      type="button"
                      className="p-2 hover:bg-slate-50 border border-slate-200 rounded-lg text-slate-500 hover:text-slate-800 transition-colors"
                      onClick={() => setAciteOption(!AciteOption)}
                    >
                      <RxDotsHorizontal size={16} />
                    </button>
                    {AciteOption && (
                      <div className="absolute right-0 mt-1 w-44 bg-white border border-slate-100 rounded-lg shadow-lg py-1 z-50 text-left">
                        {sortedAndPaginatedData?.length > 0 && (
                          <button
                            onClick={handleExport}
                            className="w-full text-left px-4 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
                          >
                            Export file results
                          </button>
                        )}
                        <label className="w-full text-left px-4 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors cursor-pointer block">
                          <input
                            type="file"
                            className="hidden"
                            onChange={uploadExcel}
                            accept=".xls,.xlsx"
                          />
                          Import Data
                        </label>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {loading && (
                <div className="flex justify-center items-center h-60">
                  <Loading />
                </div>
              )}
              {!loading && (
                <>
                  <div className="relative scroll-inner">
                    <table className="crm-table">
                      <thead>
                        <tr>
                          {permissions?.isDelete &&
                            <th scope="col" className="w-4 p-4">
                              <label className="custom-label">
                                <div className="bg-white dark:bg-slate-600/40 border border-slate-300 dark:border-slate-600 rounded w-4 h-4  inline-block leading-4 -mb-[3px]">
                                  <input
                                    type="checkbox"
                                    className=""
                                    checked={selectAllChecked}
                                    onChange={() => handleSelectAll()}
                                  />
                                </div>
                              </label>
                            </th>
                          }
                          <th scope="col" className="mw-200 p-4">
                            <div className="flex items-center w-full">
                              Title
                              <svg
                                className="w-3 h-3 ms-1.5 cursor-pointer"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 24 24"
                                onClick={() => handleSort("title")}
                              >
                                <path
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Zm-6.852 0 3.426 5.05-3.426-5.05Z"
                                />
                              </svg>
                            </div>
                          </th>
                          <th scope="col" className="mw-200 p-4 ">
                            Next Activity
                          </th>
                          <th scope="col" className="mw-200 p-4">Labels</th>
                          {/* <th scope="col" className="mw-200 p-4">Lead created</th> */}
                          {/* <th scope="col" className="mw-200 p-4">Update time</th> */}
                          {/* <th scope="col" className="mw-200 p-4">Address</th> */}
                          <th scope="col" className="mw-200 p-4">Organization</th>
                          <th scope="col" className="mw-200 p-4">Contact person</th>
                          <th scope="col" className="mw-200 p-4">Value</th>
                          <th scope="col" className="mw-200 p-4">Currency</th>
                          <th scope="col" className="mw-200 p-4">visible</th>
                          {/* <th scope="col" className="mw-200 p-4">Source</th> */}
                          {/* <th scope="col" className="mw-200 p-4">Source Channel ID</th> */}
                          {/* <th scope="col" className="mw-200 p-4">Source Channel</th> */}
                          {/* <th scope="col" className="mw-200 p-4">Expected Date</th> */}
                          {/* <th scope="col" className="mw-200 p-4">Owner</th> */}
                          {/* <th scope="col" className="mw-200 p-4">Archive time</th> */}
                          {/* <th scope="col" className="mw-200 p-4">Done activities</th> */}
                          {/* <th scope="col" className="mw-200 p-4">Activities to do</th> */}
                          {/* <th scope="col" className="mw-200 p-4">Total activities</th> */}
                          <th scope="col" className="mw-200 p-4">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sortedAndPaginatedData?.length > 0 ? (
                          sortedAndPaginatedData?.map((item, index, arr) => {
                            const getFormattedDate = (date) => {
                              const today = moment()?.startOf('day');
                              const activityDate = moment(date)?.startOf('day');

                              if (activityDate.isSame(today, 'day')) {
                                return { text: 'Today', color: 'text-green-700' };
                              } else if (activityDate?.isSame(today?.subtract(1, 'day'), 'day')) {
                                return { text: 'Yesterday', color: 'text-red-600' };
                              } else if (activityDate.isBefore(today, 'day')) {
                                return { text: moment(date).format('YYYY-MM-DD'), color: 'text-red-600' };
                              } else {
                                return { text: moment(date).format('YYYY-MM-DD'), color: 'text-gray-500' };
                              }
                            };
                            const activityDetails = item?.activityDetails?.[0];
                            const formattedDate = activityDetails ? getFormattedDate(activityDetails?.endDate) : null;
                            const showUpward = index >= arr.length - 2 && arr.length > 1;
                            return (
                              <tr
                                key={index}
                                className="hover:bg-slate-50 transition-colors cursor-pointer text-center border-b border-slate-100"
                              >
                                {permissions?.isDelete &&
                                  <td className="w-4 px-4 py-3">
                                    <label className="custom-label">
                                      <div className="bg-white dark:bg-slate-600/40 border border-slate-200 dark:border-slate-600 rounded w-4 h-4  inline-block leading-4 text-center -mb-[3px]">
                                        <input
                                          type="checkbox"
                                          checked={selectedItems.includes(
                                            item.leadID
                                          )}
                                          onChange={() =>
                                            handleCheckboxChange(item?.leadID)
                                          }
                                        />
                                      </div>
                                    </label>
                                  </td>
                                }
                                <td
                                  className="mw-200 px-4 py-3 capitalize text-sm text-slate-600 whitespace-nowrap font-medium text-left"
                                  onClick={() => infoDetailsLeads(item?.leadID)}
                                >
                                  {item?.title}
                                </td>
                                <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap text-left" onClick={() => infoDetailsLeads(item?.leadID)}>
                                  {item?.activityDetails?.length > 0 ?
                                    <div className="flex items-center justify-left gap-1">
                                      <p className={formattedDate?.color}>{getActivityIcon(activityDetails?.activityType)}</p>
                                      <p className={formattedDate?.color}>{formattedDate?.text}</p>
                                    </div>
                                    :
                                    <div className="flex items-center justify-left gap-2">
                                      <p className='text-yellow-600'>{<IoIosWarning size={17} />}</p>
                                      <p className='text-yellow-600'>No activity</p>
                                    </div>}
                                </td>
                                <td
                                  className="mw-200 px-4 py-3 text-sm whitespace-nowrap text-left"
                                >
                                  {item?.labelName && (
                                    <span
                                      className="text-xs font-semibold px-2 py-0.5 rounded-full"
                                      style={{ backgroundColor: item?.color + '20', color: item?.color }}
                                    >
                                      {item?.labelName}
                                    </span>
                                  )}
                                </td>
                                {/* <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap">
                                  {FormatDateMoment(item?.createdDate)}
                                </td> */}
                                {/* <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap">
                                  {item?.updatedDate ? moment(item?.updatedDate).format('LLL') : ''}
                                </td> */}
                                <td
                                  className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap text-left"
                                >
                                  {item?.organizationName}
                                </td>
                                <td
                                  className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap text-left"
                                >
                                  {item?.personName}
                                </td>
                                <td
                                  className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap text-left"
                                >
                                  {` ${item?.currencyCode !== null ? item?.currencyCode : ''} ${item?.value?.toLocaleString('en-IN')}`}
                                </td>
                                <td
                                  className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap text-left"
                                >
                                  {item?.currencyName}
                                </td>
                                <td
                                  className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap text-left"
                                >
                                  {item?.visibleName}
                                </td>
                                {/* <td
                                  className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap"
                                >
                                  {item?.sourceType}
                                </td>
                                <td className="mw-200 p-3 text-sm text-center text-slate-500 whitespace-nowrap">
                                  {item?.sourceChannelID}
                                </td>
                                <td className="mw-200 p-3 text-sm text-center text-slate-500 whitespace-nowrap">
                                  {item?.sourceChannel}
                                </td>
                                <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap" >
                                  {item?.expectedCloseDate ? FormatDateMoment(item?.expectedCloseDate) : ''}
                                </td>
                                <td
                                  className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap"
                                  onClick={() => infoDetailsLeads(item?.leadID)}
                                >
                                  {item?.ownerID}
                                </td>
                                <td
                                  className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap"
                                  onClick={() => infoDetailsLeads(item?.leadID)}
                                >
                                  {item?.isArchived && item?.archiveTime ? moment(item?.archiveTime).format('LLL') : ''}
                                </td> 
                                <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap cursor-pointer">{item?.doneActivity}</td>
                                <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap cursor-pointer">{item?.activitiesToDo}</td>
                                <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap cursor-pointer">{item?.totalActivities}</td>*/}
                                <td className="px-4 py-3 text-left whitespace-nowrap">
                                  <div className="relative inline-block text-left">
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setOpenActionMenuId(openActionMenuId === item.leadID ? null : item.leadID);
                                      }}
                                      className="p-1.5 text-slate-500 hover:text-slate-800 hover:bg-slate-100 rounded-lg transition-colors"
                                    >
                                      <BsThreeDotsVertical size={16} />
                                    </button>
                                    {openActionMenuId === item.leadID && (
                                      <div className={`absolute right-0 w-36 bg-white border border-slate-100 rounded-lg shadow-lg py-1 z-50 animate-in fade-in duration-100 flex flex-col ${showUpward ? 'bottom-full mb-1 slide-in-from-bottom-1' : 'top-full mt-1 slide-in-from-top-1'}`}>
                                        {permissions?.isSave && (
                                          <button
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              editLead(item?.leadID);
                                              setOpenActionMenuId(null);
                                            }}
                                            className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-left"
                                          >
                                            <BiEdit size={14} className="text-indigo-500" />
                                            <span>Edit</span>
                                          </button>
                                        )}
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            const payload = {
                                              LeadID: item?.leadID,
                                              IsArchived: item?.isArchived ? false : true,
                                            };
                                            dispatch(archiveLeadData(payload)).then((res) => {
                                              setLoadFist(true);
                                            });
                                            setOpenActionMenuId(null);
                                          }}
                                          className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-left"
                                        >
                                          <GoArchive size={14} className="text-indigo-500" />
                                          <span>{item?.isArchived ? 'UnArchive' : 'Archive'}</span>
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            )
                          })
                        ) : (
                          <tr>
                            <td colSpan="8" className="text-center py-4">
                              Data not found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagination name='Leads' handlePageChange={handlePageChange} setCurrentPage={setCurrentPage} currentPage={currentPage} sidebarOpen={sidebarOpen} totalPages={totalPages} length={store?.leadsData?.length} setrowsPerPage={setrowsPerPage} rowsPerPage={rowsPerPage} />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {openModel && (
        <AddLeads
          togglemodelLead={togglemodelLead}
          leadData={leadData}
          setLoadFistInbox={setLoadFist}
        />
      )}
    </>
  );
};

export default Inbox;


